import "./ProductPannel.css";

export default function ProductPanel({ title, open, onClick, children }) {
  return (
    <div className="product-panel">
      <button
        className={`panel-header${open ? " open" : ""}`}
        onClick={onClick}
        aria-expanded={open}
      >
        <span>{title}</span>

        <span
          className={`panel-toggle-icon${open ? " open" : ""}`}
          aria-hidden="true"
        >
          +
        </span>
      </button>

      <div
        className={`panel-content${open ? " open" : ""}`}
        style={{
          maxHeight: open ? 600 : 0,
        }}
      >
        <div className="panel-inner">{children}</div>
      </div>
    </div>
  );
}
